import React from 'react';
import { Layout } from 'antd';
import './style.css'
import ServiceProviderHeader from '../../Header/ServiceProviderHeader';

const { Content } = Layout;

const ServiceProviderLayout = ({ children }) => {

    return (
        <Layout>
            <ServiceProviderHeader />
            <Content
                className='p-2 px-4 md:px-8 min-h-screen max-w-7xl mx-auto w-full'>
                {children}
            </Content>
        </Layout>
    );
};
export default ServiceProviderLayout;